const stats = [
  { value: '20 Min.', label: 'einmal pro Woche', icon: 'ri-time-line' },
  { value: '1 : 1', label: 'Betreuung garantiert', icon: 'ri-user-heart-line' },
  { value: '5,0 ★', label: 'auf Google', icon: 'ri-star-line' },
  { value: '500+', label: 'Kunden in Pinneberg', icon: 'ri-group-line' },
  { value: '0 €', label: 'Probetraining', icon: 'ri-gift-line' },
];

export default function StatsBar() {
  return (
    <div className="relative z-10 border-b" style={{ backgroundColor: '#F7FAF8', borderColor: '#E4EDE8' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-x" style={{ divideColor: '#E4EDE8' }}>
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center py-5 px-4 gap-1 border-r last:border-r-0"
              style={{ borderColor: '#E4EDE8' }}
            >
              <div
                className="text-xl font-bold tracking-tight"
                style={{ fontFamily: 'Playfair Display, serif', color: '#1A5C3D' }}
              >
                {stat.value}
              </div>
              <div
                className="text-xs text-center leading-tight"
                style={{ fontFamily: 'Inter, sans-serif', color: '#8A9E94', fontWeight: 400 }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
